import './bar_chart_view.js.coffee';# Added by Script 
import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.FansAgeGenderDistributionView extends Monitoring.Reports.Executive.BarChartView 
  genericTemplate: JST["backbone/templates/monitoring/reports/executive/generic_template"]
  tagName: 'section'
  chartClass: 'column-chart'
  icon: 'column'

  initialize: (@options = {}) ->
    @colors = @options.colors
    @target = { fans: @options.chartApi.fans_gender}

  _columnOptions: (response, divId) =>
    male = {}
    female = {}
    unknown = {}
    for k,v of response
        if k.substring(0,1) == "M" then ages = male else if k.substring(0,1) == "F" then ages = female else ages = unknown
        if ages[k.substring(2)] then ages[k.substring(2)] += v else ages[k.substring(2)] = v
    hashSeries = {}

    hashSeries["Masculino"] = [male["13-17"] || 0, male["18-24"] || 0, male["25-34"] || 0, male["35-44"] || 0, male["45-54"] || 0, male["55-64"] || 0, male["65+"] || 0]
    hashSeries["Femenino"] = [female["13-17"] || 0, female["18-24"] || 0, female["25-34"] || 0, female["35-44"] || 0, female["45-54"] || 0, female["55-64"] || 0, female["65+"] || 0]
    hashSeries["Desconocido"] = [unknown["13-17"] || 0, unknown["18-24"] || 0, unknown["25-34"] || 0, unknown["35-44"] || 0, unknown["45-54"] || 0, unknown["55-64"] || 0, unknown["65+"] || 0]

    series = _.map(hashSeries, (values, index) => { name: index, data: values, color: @colors[index.toLowerCase()] })
    serie.type = 'column' for serie in series
    categories = ["13 - 17", "18 - 24", "25 - 34", "35 - 44", "45 - 54","55 - 64", "65+"]

    _.extend(@highchartsColumnOptions(divId, series, categories), { legend: enabled: true })
